import type { NdHandling } from '@/api/dataVault';

interface Props {
  value: NdHandling;
  onChange: (v: NdHandling) => void;
}

const OPTIONS: { value: NdHandling; label: string; title?: string }[] = [
  { value: 'half_mdl', label: '½ MDL', title: 'Substitute non-detects with half the lab detection limit' },
  { value: 'zero',     label: '0',     title: 'Substitute non-detects with zero' },
  { value: 'mdl',      label: 'MDL',   title: 'Substitute non-detects with the lab detection limit' },
  { value: 'less_than', label: '<DL',  title: 'Display non-detects as "<{detection limit}" — matches lab report style' },
  { value: 'exclude',  label: 'EXCLUDE', title: 'Hide non-detects entirely' },
];

export function NonDetectToggle({ value, onChange }: Props) {
  return (
    <div className="flex items-center gap-1">
      <span className="text-xs text-mono-300 tracking-wider mr-1">ND:</span>
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          title={opt.title}
          className={`px-2 py-1 text-xs tracking-wider rounded transition-colors ${
            value === opt.value
              ? 'bg-mono-700 text-mono-100'
              : 'text-mono-500 hover:text-mono-300 hover:bg-mono-800'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
